export default {
  wopiTest: [
    'what_is_wopi',
    'what_is_wopi_description',
    'confidentiality_agreement',
    'confidentiality_agreement_subtitle',
    'confidentiality_agreement_text',
    'confidentiality_agreement_consent_label',
    'personal_information',
    'given_name',
    'family_name',
    'age',
    'sex',
    'female',
    'male',
    'other',
    'mandatory_description',
    'next',
    'instructions',
    'think_about_work',
    'think_about_work_description',
    'no_right_or_wrong',
    'no_right_or_wrong_description',
    'duration',
    'duration_description',
    'start_questionnaire',
    'true',
    'false',
    'halfway',
    'continue',
    'welldone',
    'wopi_is_done_thank_you',
    'something_went_wrong_please_refresh_page',
    'refresh_the_page',
    'questionnaire_not_found',
    'questionnaire_closed',
    'leaving_test_in_progress'
  ],
  wopiProfile: [
    'less_focused',
    'very_focused_quality_oriented',
    'less_competitive',
    'very_competitive_results_oriented',
    'not_leading_of_others',
    'strongly_leading_of_others',
    'reserved_unassuming',
    'steps_forward_inspires_others',
    'solitary_withdrawing',
    'seeks_contacts_communicates',
    'distant_remote',
    'supports_advises_others',
    'autonomous_self_sufficient',
    'relies_on_listens_to_others',
    'pursues_facts',
    'pursues_ideas',
    'concrete_perception',
    'abstract_perception',
    'analytical_logical_thinking',
    'intuitive_instinctive_thinking',
    'cautious_controlled_decisions',
    'quick_risk_taking_decisions',
    'prefers_clarity_stability',
    'prefers_novelty_change',
    'less_optimism',
    'much_optimism',
    'much_self_reflection',
    'less_self_reflection',
    'achievement_motives',
    'independent_action',
    'leadership_motives',
    'leadership',
    'interaction_motives',
    'collaboration',
    'thinking',
    'standard',
    'creative',
    'planning_problem_solving',
    'attitudes',
    'viewing',
    'teamleader',
    'organizes_action',
    'controller',
    'controls_action',
    'collaborator',
    'communicates_with_others',
    'specialist',
    'focuses_on_the_task',
    'idea_generator',
    'seeks_novelty',
    'thinker',
    'doer',
    '1_way_communication',
    '2_way_communication',
    'sees_many_problems',
    'does_not_see_problems',
    'introvert',
    'extrovert',
    'cautious',
    'impulsive',
    'protective_factors',
    'seeks_contacts_with_others',
    'human_relations',
    'attitude_to_change',
    'change_novelty_preferring',
    'realism',
    'optimism',
    'anticipates_success',
    'vulnerabilities',
    'no_a_typicality',
    'a_typicality',
    'no_burnout',
    'burnout',
    'basic_profile',
    'team_roles',
    'roles',
    'work_wellbeing',
    'norm',
    'general_norm',
    'confidential',
    'raw_points',
    'standard_score_percentage',
    'standard_scores',
    'competency_drivers',
    'basic_competencies',
    'implementer',
    'innovator',
    'decision_making',
    'execution',
    'drivers',
    'competences',

    'date',
    'name',
    'sex',
    'role',
    'organisation',
    'language'
  ],
  wopi360Test: [
    'answer_1',
    'answer_2',
    'answer_3',
    'answer_4',
    'answer_5',
    'answer_6',
    'answer_7',

    'to_admin_view',
    'target_person_is',
    'evaluated_target_person_is',
    'evaluate_persons_work',
    'evaluate_persons_work_description',
    'answer_honestly',
    'answer_honestly_description',
    'answering_will_take',
    'answering_will_take_description',
    'i_accept',
    'the_confidentiality_agreement',
    'terms_and_conditions',
    'terms_and_conditions_description',
    'close',
    'start_questionnaire',

    'select_role',
    'select_role_description',
    'role_coworker',
    'role_manager',
    'role_employee',
    'role_other',
    'role_other_description',
    'continue',

    'focus',
    'efficiency',
    'giving_direction',
    'inspiration',
    'resourcing',
    'communicating',
    'advising',
    'listening',
    'standard_existing_processes',
    'creative_new_processes',
    'change',

    'open_answer_1',
    'open_answer_1_description',
    'open_answer_2',
    'open_answer_2_description',

    'complete'
  ],
  wopi360Profile: [
    'not_at_all',
    'in_between',
    'very_well',

    'self',
    'manager',
    'other',

    'focus',
    'efficiency',
    'giving_direction',
    'inspiration',
    'resourcing',
    'communicating',
    'advising',
    'listening',
    'standard_existing_processes',
    'creative_new_processes',
    'change',
    'change_management',

    'wopi_360_results',
    'dear_recipient',
    'competent_behaviors',
    'competent_behaviors_description_part1',
    'competent_behaviors_description_part2',
    'summary',
    'summary_description',
    'independent_performance',
    'focused_and_quality_oriented',
    'efficient_and_result_oriented',
    'cooperation',
    'communicating_and_contact_creating',
    'advising_and_supporting',
    'listening_and_serving',
    'leadership',
    'showing_direction_and_determined',
    'inspiring_and_uplifting',
    'resourcing_and_equipping',
    'planning_and_problem_solving',
    'operative_supporting_existing_processes',
    'creative_creating_new_processes',
    'open_answers',
    'strengths',
    'mention_one_strength',
    'development_points',
    'mention_one_development_point',
    'stability_vs_change_preference',
    'competence_dimensions',
    'competent_behavior',

    'unit_competent_behaviors_description',

    'unit_targets',
    'unit_targets_description',
    'target',
    'role',
    'evaluators',
    'closed_at',
    'manager_profile',
    'pcs',
    'yes',
    'no',

    'units_average_profile',
    'chosen_units',
    'chosen_units_description',
    'evaluated_targets',
    'unit',
    'total'
  ],
  groupDriversProfile: [
    'group_drivers_profile',
    'confidential',
    'background_profile',
    'sample_size',
    'less_quality_emphasis',
    'strong_quality_emphasis',
    'less_result_emphasis',
    'strong_result_emphasis',
    'compliance_yielding',
    'assertion_power',
    'moderation_restraint',
    'promotion_display',
    'disengagement_withdrawal',
    'communication_contacts',
    'distance_neutrality',
    'advisory_support',
    'autonomy_self_sufficiency',
    'listening_serving',
    'action',
    'planning_problem_solving',
    'current_processes',
    'novel_processes',
    'emphasis_on_facts',
    'emphasis_on_ideas',
    'focused_perception',
    'broad_perception',
    'standard_solutions',
    'creative_solutions',
    'cautious_implementation',
    'risky_implementation',
    'viewing',
    'stable_world',
    'mobile_world',
    'realism',
    'optimism',
    'much_self_reflection',
    'less_self_reflection'
  ],
  groupRolesProfile: [
    'group_roles',
    'confidential',
    'thinker',
    'thinks_and_weighs',
    'doer',
    'acts_and_performs',
    'introvert',
    'focused_on_matters',
    'extrovert',
    'creates_relationships',
    'implementer',
    'implements_existing_processes',
    'inventor',
    'creates_new_processes'
  ],
  emails: [
    'wopi_questionnaire_has_been_completed',
    'has_completed_questionnaire',
    'activate_account',
    'activation_description',
    'reset_password',
    'password_reset_description',
    'best_regards',
    'helpdesk_signature',
    'invitation_link_description',
    'low_wopi_credits',
    'low_wopi_credits_description_part1',
    'low_wopi_credits_description_part2',
    'wopi360_invitation',
    'wopi360_invitation_description', // {{targetPerson}}, {{deadlineAt}}
    'wopi360_invitation_link_description',
    'wopi360_target_invitation',
    'wopi360_target_invitation_description', // {{deadlineAt}}
    'wopi360_target_invitation_link_description',
    'wopi360_target_invitation_with_can_invite',
    'wopi360_target_invitation_with_can_invite_description', // {{deadlineAt}}
    'invitation_privacy_statement_description',
    'invitation_privacy_statement_url',
    'invitation_transactional_disclaimer',
    'wopi360_deadline_reminder', // {{deadlineAt}}
    'wopi360_deleted_notify',
    'wopi360_deleted_notify_target_deletion', // {{targetPerson}}
    'wopi360_deleted_notify_deletion', // {{targetPerson}}
    'wopi360_deleted_notify_contact_admin',
    'wopi_deleted_notify',
    'wopi_deleted_notify_description',
    'wopi_deleted_notify_contact_admin'
  ],
  ui: [
    'given_name',
    'family_name',
    'email',
    'email_address',
    'password',
    'verify_password',
    'login_failed',
    'forgot',
    'forgot_password',
    'send_link_to_email',
    'password_reset_sent',
    'check_your_mail',
    'no_account_found_with_this_email',
    'reset_password',
    'set_password',
    'login',
    'log_in',
    'log_out',
    'activate_your_account',
    'activate_account_description',
    'verify',
    'link_invalid',
    'save',
    'next',
    'select',
    'date',
    'or',
    'yes',
    'cancel',
    'finnish',
    'english',
    'swedish',
    'russian',
    'german',
    'estonian',
    'lithuanian',
    'latvian',
    'role',
    'organisation',
    'organisation_and_role',
    'language',
    'pcs',
    'download',
    'oops',
    'not_found_description',
    'back_to_home',
    'loading',
    'year',
    'month',
    'name',
    'notes',
    'support',
    'customer_service',
    'customer_service_description',
    'customer_service_number_text',
    'customer_service_email_text',
    'analysis_page_title',
    'analysis_page_description',
    'analysis_page_and_work_wellbeing_title',
    'analysis_page_and_work_wellbeing_description',
    'dimension_specs_title',
    'dimension_specs_description',
    'key_slides_title',
    'key_slides_description',
    'quick_reference_title',
    'quick_reference_description',
    'model_report_title',
    'model_report_description',
    'leadership_roles_self_evaluation_title',
    'leadership_roles_self_evaluation_description',
    'group_basics_title',
    'group_basics_description',
    'example_questions_title',
    'example_questions_description',
    'wopi_extra_profiles_and_work_wellbeing_title',
    'wopi_extra_profiles_and_work_wellbeing_description',
    'wopi_extra_profiles_title',
    'wopi_extra_profiles_description',
    'data_processing_title',
    'data_processing_description',

    'questionnaires',
    'respondent',
    'profile',
    'new_questionnaire',
    'wopi_results',
    'open_invitations',
    'actions_for_selected',
    'settings_for_profile_files',
    'work_wellbeing_profile',
    'support_pages',
    'profile_attachments',
    'search_for_questionnaires',
    'questionnaire_extra_information',
    'questionnaire_extra_information_description',
    'questionnaire_invitations',
    'invitation_subject',
    'invitation_message',
    'invitation_organisation_description',
    'invitation_role_description',
    'signature',
    'edit_your_signature_description',
    'recipients',
    'recipients_description',
    'check_invalid_emails',
    'generated_invitation_link_here_description',
    'send_invitations',
    'invitation_to_wopi',
    'invitation_message_wopi',
    'invitation_start_link',
    'invitation_language',
    'invitation_emails_sent',
    'invitations_sent_to',
    'product_selection_wopi_description',
    'something_went_wrong_invitation',
    'dismiss_invitation_error',
    'no_results',
    'questionnaires_will_be_listed_here',
    'invitations_will_be_listed_here',
    'link_to_questionnaire',
    'questionnaire_link_description_sent_to',
    'close',
    'download_pdf',
    'deselect',
    'compare',
    'actions',
    'delete',
    'deleted',
    'are_you_sure',
    'show_only_own',
    'download_analysis_pages',
    'min',
    'duration',
    'questionnaire_is_about_to_expire',
    'notification_profile_deletion_description',
    'notification_profile_as_administrator_description',

    'group_drivers',
    'wopi_profiles',
    'group_drivers_introduction',
    'selected_profiles',
    'download_group_drivers',
    'name_for_group',

    'group_roles',
    'group_roles_introduction',
    'download_group_roles',

    'ui_language',
    'own_settings',

    'super_admin_settings',
    'translations',
    'accounts',
    'invoicing',
    'is_super_admin',
    'new_account',
    'delete_account',
    'invitation_sent',
    'send_activation_mail',
    'activation_link',
    'customer_organisations',
    'translations_for_wopiQuestions',
    'translations_for_wopiTest',
    'translations_for_wopiProfile',
    'translations_for_wopi360Questions',
    'translations_for_wopi360Test',
    'translations_for_wopi360Profile',
    'translations_for_groupDriversProfile',
    'translations_for_groupRolesProfile',
    'translations_for_emails',
    'translations_for_ui',
    'new_organisation',
    'edit_organisation',
    'organisation_name',
    'unit_price_wopi',
    'mail_to_wopi_helpdesk',
    'usage',
    'questionnaire_type',
    'privileges',
    'role_member',
    'role_member_description',
    'role_admin',
    'role_admin_description',
    'or_create_new',
    'management',
    'user_information',
    'duplicate_email',
    'usage_log',
    'promote_to_admin',
    'admin_privileges',
    'wopi_credits_history',
    'wopi_credits',
    'wopi360_credits',
    'wopi_credits_left',
    'wopi360_credits_left',
    'add_wopi_credits',
    'add_wopi360_credits',
    'invitation_no_more_wopi_credits',
    'dismiss_no_more_wopi_credits',
    'order_more_wopi_credits',
    'order_more_wopi360_credits',
    'order_more_wopi_credits_title',
    'order_more_wopi_credits_by_contacting',
    'order_more_wopi_credits_or_by_phone',
    'wopi_credits_credits',
    'wopi_credits_added_at',
    'wopi_credits_added_by',
    'delete_wopi_title',
    'delete_wopi_description',
    'delete_wopi',
    'delete_organisation_title',
    'delete_organisation_description',
    'delete_organisation',

    'wopi360',
    'new_wopi360_target',
    'open_new_wopi360_target',
    'target_person_information',
    'test_deadline',
    'deadline',
    'last_day_to_answer',
    'choose_from_calendar',
    'number_of_replies',
    'number_of_recipients_responded',
    'ask_manager_questions',
    'target_person',
    'sent_at',
    'finished_at',
    'opened_at',
    'closed_at',
    'invited',
    'close_test',
    'copy_test_link',
    'close_test_confirm_deadline_upcoming',
    'close_test_confirm_deadline_passed',
    'recipients_have_answered',
    'invite_manager',
    'invite_recipients',
    'manager_already_invited',
    'open_targets',
    'closed_targets',
    'search_for_targets',
    'open_targets_will_be_listed_here',
    'closed_targets_will_be_listed_here',
    'target_was_closed',
    'target_is_closed',
    'continue',
    'invite_recipients_to_wopi360',
    'recipients_in_finnish',
    'recipients_in_english',
    'who_to_invite',
    'invite_description_part1',
    'invite_description_part2',
    'invite_description_part3',
    'invite_description_part4',
    'invite_description_manager',
    'invite_description_coworker',
    'invite_description_employee',
    'invite_description_other',
    'questions',
    'more_information_from',
    'edit_wopi360_target',
    'edit_targets_basic_information',
    'link_to_wopi360_profile',
    'link_to_wopi360_test',
    'wopi360_test_link_description_sent_to',
    'target_person_can_invite_recipients',
    'wopi360_test_status',
    'role_coworker',
    'role_manager',
    'role_employee',
    'role_other',
    'target_person_and_role',
    'organisation_and_units',
    'test_state',
    'test_state_open',
    'test_state_closed',
    'test_state_expired',
    'attach_target_to_units',

    'support_page_error',

    'invitationMethod',
    'linkOnly',
    'recipients_count',
    'check_recipients_count',
    'generate_links',
    'links_generated',
    'links_generated_successfully',
    'links_generated_explanation',
    'questionnaire_link_created',
    'link_created',

    'units',
    'unit_create_new',
    'unit_edit',
    'units_will_be_listed_here',
    'unit_wopi360_profiles',
    'unit_name',
    'unit_description',
    'unit_attached_with_wopi360s_will_be_listed_here',
    'unit_download_wopi360_results_and_average',
    'unit_remove_360_target',
    'unit_attach_360_targets',
    'unit_choose_360_targets_to_attach',
    'attach',

    'organisation_data',
    'download_organisation_wopi_csv',
    'download_organisation_wopi_csv_include_expired',
    'download_organisation_explanation_heading',
    'download_organisation_explanation_content',
    'questionnaire_opened',
    'questionnaire_closed',

    'send_reminder',
    'send',
    'send_reminders_to_participants',
    'send_reminders_to_participants_description',
    'sent',
    'invite_feedback_explanation',
    'manager_position',
    'yes',
    'no',
    'close_test_target_unanswered_description',
    'close_test_target_unanswered_confirmation',
    'email_disclaimer_checkbox_label'
  ]
}



// WEBPACK FOOTER //
// ./src/assets/translations/translationKeysForServer.js